import { W as WuiEmptyState$1, d as defineCustomElement$1 } from './p-DJoZV0_6.js';

const WuiEmptyState = WuiEmptyState$1;
const defineCustomElement = defineCustomElement$1;

export { WuiEmptyState, defineCustomElement };
